(function(){
  'use strict';

  document.querySelectorAll('script[data-section-id]').forEach(initSection);

  function initSection(scriptEl){
    const sectionId = scriptEl.getAttribute('data-section-id');
    const root = document.getElementById('ds-root-' + sectionId);
    if (!root || root.dataset.dsInit) return;
    root.dataset.dsInit = '1';

    const dataEl = document.getElementById('ds-product-data-' + sectionId);
    let productData = { variants: [] };
    try { productData = JSON.parse(dataEl.textContent); } catch(e){ /* leave empty */ }

    // ---- config ----
    const SHAPES = {
      rectangle: { label:'Rectangle' },
      arch:      { label:'Arch' },
      wavy:      { label:'Wavy' },
      bowed:     { label:'Bowed Edge' },
      diagonal:  { label:'Diagonal Cut' }
    };
    const ACCENTS = {
      none:   { label:'None', needsColor:false },
      stripe: { label:'Side Stripe',        needsColor:true },
      bands:  { label:'Top & Bottom Bands', needsColor:true },
      shadow: { label:'Offset Shadow',      needsColor:true },
      split:  { label:'Two-Tone Split',     needsColor:true },
      banner: { label:'Banner Swoosh',      needsColor:true }
    };
    const ACCENT_COLORS = {
      charcoal: { label:'Charcoal', hex:'#2B2E33' },
      red:      { label:'Red',      hex:'#8C2F2A' },
      brass:    { label:'Brass',    hex:'#C6A05F' },
      sage:     { label:'Sage',     hex:'#6B7A5E' },
      custom:   { label:'Custom',   hex:null }
    };
    const MATERIALS = {
      standard:  { label:'1/8" Acrylic/Rowmark',              engrave:'#241D0F' },
      backplate: { label:'1/8" Acrylic/Rowmark + Backplate',  engrave:'#241D0F' }
    };
    const TYPEFACES = {
      serif: { label:'Classic Serif', family:"Georgia, 'Times New Roman', serif", weight:600 },
      sans:  { label:'Modern Sans',   family:"-apple-system, Helvetica, Arial, sans-serif", weight:700 },
      script:{ label:'Script',        family:"'Snell Roundhand', 'Brush Script MT', 'Segoe Script', cursive", weight:400 }
    };
    // Wider than the Room Number presets — directional signs are read at a
    // glance from across a hallway, not up close, so they're bar-shaped and
    // sized to the number of destination lines they'll typically carry.
    const SIZES = {
      single:    { label:'Single Line',  w:12, h:4 },
      double:    { label:'Double Line',  w:14, h:6 },
      triple:    { label:'Triple Line',  w:16, h:8 },
      directory: { label:'Directory (up to 8 lines)', w:16, h:14 }
    };
    const MOUNTINGS = {
      flush:    { label:'Flush Wall-Mount' },
      standoff: { label:'Standoff Mount' }
    };
    const ICONS = { none:{label:'None'}, access:{label:'Accessible Route'} };
    const DIRECTIONS = {
      right: { label:'→', arrow:'\u2192' },
      left:  { label:'←', arrow:'\u2190' },
      up:    { label:'↑', arrow:'\u2191' },
      down:  { label:'↓', arrow:'\u2193' },
      none:  { label:'—', arrow:'' }
    };


    let state = {
      headingText:'This Way',
      destinations: [
        { label:'Pool', direction:'right' },
        { label:'Elevators', direction:'left' },
        { label:'Fitness Center', direction:'up' }
      ],
      shape:'rectangle', material:'standard', typeface:'sans',
      size:'double', mounting:'flush', icon:'none',
      plateColor:'#2B2E33', textColor:'#F2ECDE', textColorManual:true,
      accent:'none', accentColor:'brass', accentCustomColor:'#8C2F2A'
    };

    const variantMap = {};
    productData.variants.forEach(v=>{ variantMap[v.size + '|' + v.material + '|' + v.mounting] = v; });
    function findVariant(){
      const key = SIZES[state.size].label + '|' + MATERIALS[state.material].label + '|' + MOUNTINGS[state.mounting].label;
      return variantMap[key] || null;
    }

    function escapeXml(s){ return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

    // Same wheelchair pictogram used on the Room Number builder, reused here
    // for the optional "Accessible Route" indicator.
    function accessIconMarkup(color){
      return `<path d="M 173.101562 109.238281 C 189.375 107.734375 202.019531 93.714844 202.019531 77.316406 C 202.019531 59.667969 187.617188 45.269531 169.972656 45.269531 C 152.324219 45.269531 137.925781 59.667969 137.925781 77.316406 C 137.925781 82.699219 139.425781 88.207031 141.929688 92.839844 L 153.347656 253.511719 L 270.953125 253.546875 L 319.1875 366.566406 L 382.515625 341.730469 L 372.710938 318.378906 L 337.269531 331.171875 L 290.597656 223.425781 L 181.253906 224.160156 L 179.753906 203.8125 L 258.90625 203.84375 L 258.90625 173.738281 L 176.734375 173.703125 L 173.105469 109.234375 Z" fill="${color}"/><path d="M 291.375 339.664062 C 271.527344 378.898438 229.984375 404.75 185.671875 404.75 C 120.585938 404.75 67.5 351.664062 67.5 286.578125 C 67.5 240.878906 95.195312 198.414062 136.523438 179.589844 L 139.199219 214.488281 C 114.753906 229.894531 99.683594 257.6875 99.683594 286.820312 C 99.683594 334.035156 138.195312 372.542969 185.410156 372.542969 C 228.605469 372.542969 265.4375 339.394531 270.464844 296.863281 L 291.378906 339.660156 Z" fill="${color}"/>`;
    }

    function archPathD(x,y,w,h){
      const topY = y + h*0.24;
      return `M ${x} ${y+h} L ${x} ${topY} A ${w/2} ${topY-y} 0 0 1 ${x+w} ${topY} L ${x+w} ${y+h} Z`;
    }
    function wavyPathD(x,y,w,h){
      const iw = w*0.06;
      return `M ${x+iw} ${y} L ${x+w-iw} ${y} C ${x+w-iw*2.4} ${y+h*0.3}, ${x+w-iw*2.4} ${y+h*0.7}, ${x+w-iw} ${y+h} L ${x+iw} ${y+h} C ${x+iw*2.4} ${y+h*0.7}, ${x+iw*2.4} ${y+h*0.3}, ${x+iw} ${y} Z`;
    }
    function diagonalPathD(x,y,w,h){
      const cut = Math.min(w,h)*0.16;
      return `M ${x} ${y} L ${x+w-cut} ${y} L ${x+w} ${y+cut} L ${x+w} ${y+h} L ${x} ${y+h} Z`;
    }
    function bowedPathD(x,y,w,h){
      const b = w*0.05;
      return `M ${x+b} ${y} Q ${x-w*0.025} ${y+h/2} ${x+b} ${y+h} L ${x+w} ${y+h} L ${x+w} ${y} Z`;
    }
    function shapeMarkup(shape, x, y, w, h, attrs, rx){
      rx = (rx===undefined) ? 8 : rx;
      switch(shape){
        case 'arch': return `<path d="${archPathD(x,y,w,h)}" ${attrs}/>`;
        case 'wavy': return `<path d="${wavyPathD(x,y,w,h)}" ${attrs}/>`;
        case 'bowed': return `<path d="${bowedPathD(x,y,w,h)}" ${attrs}/>`;
        case 'diagonal': return `<path d="${diagonalPathD(x,y,w,h)}" ${attrs}/>`;
        default: return `<rect x="${x}" y="${y}" width="${w}" height="${h}" rx="${rx}" ${attrs}/>`;
      }
    }
    function standoffPoints(shape, x, y, w, h){
      const inset = (shape==='rectangle') ? 20 : Math.max(w,h)*0.07;
      return [[x+inset,y+inset],[x+w-inset,y+inset],[x+inset,y+h-inset],[x+w-inset,y+h-inset]];
    }
    function accentColorHex(){
      return state.accentColor==='custom' ? state.accentCustomColor : ACCENT_COLORS[state.accentColor].hex;
    }
    function offsetShadowMarkup(shape, px, py, w, h, color){
      return shapeMarkup(shape, px+w*0.03, py+h*0.06, w, h, `fill="${color}"`, 8);
    }
    function accentOverlayMarkup(accent, px, py, w, h, color){
      switch(accent){
        case 'stripe': return `<rect x="${px}" y="${py}" width="${w*0.1}" height="${h}" fill="${color}"/>`;
        case 'bands': {
          const bandH = h*0.14;
          return `<rect x="${px}" y="${py}" width="${w}" height="${bandH}" fill="${color}"/><rect x="${px}" y="${py+h-bandH}" width="${w}" height="${bandH}" fill="${color}"/>`;
        }
        case 'split': return `<polygon points="${px+w},${py} ${px+w},${py+h} ${px+w*0.62},${py+h}" fill="${color}"/>`;
        case 'banner': {
          const y0 = py+h*0.08, y1 = py+h*0.2;
          return `<path d="M ${px} ${y0+h*0.03} C ${px+w*0.3} ${y0-h*0.04}, ${px+w*0.7} ${y0+h*0.05}, ${px+w} ${y0-h*0.01}
                   L ${px+w} ${y1-h*0.01} C ${px+w*0.7} ${y1+h*0.05}, ${px+w*0.3} ${y1-h*0.04}, ${px} ${y1+h*0.03} Z"
                   fill="${color}" opacity="0.9"/>`;
        }
        default: return '';
      }
    }
    function materialFillDefs(uid, customColor){
      const c = customColor || '#2B2E33';
      return `<linearGradient id="fill-${uid}" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="${c}"/><stop offset="1" stop-color="${c}"/></linearGradient>`;
    }
    function shadowFilter(mounting){
      const isStandoff = mounting==='standoff';
      const dx = isStandoff?10:3, dy = isStandoff?14:4, b = isStandoff?10:3;
      return `filter:drop-shadow(${dx}px ${dy}px ${b}px rgba(0,0,0,0.45))`;
    }

    // ---- WCAG contrast ratio — still the relevant check for directional
    // signs (§703.5.7 requires high contrast), unlike braille/raised chars
    // which don't apply to this sign type at all ----
    function hexToRgb(hex){
      hex = String(hex).replace('#','');
      if (hex.length===3) hex = hex.split('').map(c=>c+c).join('');
      const num = parseInt(hex,16);
      return [(num>>16)&255, (num>>8)&255, num&255];
    }
    function relLuminance(hex){
      const [r,g,b] = hexToRgb(hex).map(v=>{ v/=255; return v<=0.03928 ? v/12.92 : Math.pow((v+0.055)/1.055,2.4); });
      return 0.2126*r+0.7152*g+0.0722*b;
    }
    function contrastRatio(hex1,hex2){
      const L1=relLuminance(hex1), L2=relLuminance(hex2);
      return (Math.max(L1,L2)+0.05)/(Math.min(L1,L2)+0.05);
    }

    function buildChipRow(container, options, key, disableFn){
      container.innerHTML = '';
      Object.keys(options).forEach(k=>{
        const opt = options[k];
        const btn = document.createElement('button');
        btn.className = 'ss-chip';
        btn.type = 'button';
        btn.textContent = opt.label;
        if (disableFn && disableFn(k, opt)) btn.classList.add('disabled');
        if (state[key] === k) btn.classList.add('active');
        btn.addEventListener('click', ()=>{
          if (btn.classList.contains('disabled')) return;
          state[key] = k;
          render();
        });
        container.appendChild(btn);
      });
    }

    // ---- destinations table (same interaction pattern as the Room Number
    // builder's bulk rooms table: rebuild only when row count changes, else
    // just refresh values so typing doesn't steal focus every keystroke) ----
    function buildDestTable(container){
      const rows = container.querySelectorAll('.ss-room-row');
      if (rows.length !== state.destinations.length){
        container.innerHTML = '';
        state.destinations.forEach((d,i)=> container.appendChild(buildDestRow(d,i)));
        return;
      }
      state.destinations.forEach((d,i)=>{
        const row = rows[i];
        const labelInput = row.querySelector('.ss-room-sub');
        if (document.activeElement !== labelInput) labelInput.value = d.label;
        row.querySelectorAll('.ss-room-icon-toggle').forEach(btn=>{
          btn.classList.toggle('active', d.direction === btn.dataset.dir);
        });
      });
    }
    function buildDestRow(d, i){
      const row = document.createElement('div');
      row.className = 'ss-room-row';

      const labelInput = document.createElement('input');
      labelInput.type = 'text'; labelInput.className = 'ss-room-sub'; labelInput.maxLength = 24;
      labelInput.placeholder = 'Destination (e.g. Pool)'; labelInput.value = d.label;
      labelInput.addEventListener('input', e=>{ d.label = e.target.value; render(); });

      const dirsWrap = document.createElement('div');
      dirsWrap.className = 'ss-room-icons';
      Object.keys(DIRECTIONS).forEach(k=>{
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ss-room-icon-toggle' + (d.direction===k ? ' active' : '');
        btn.dataset.dir = k;
        btn.textContent = DIRECTIONS[k].label;
        btn.title = k;
        btn.addEventListener('click', ()=>{ d.direction = k; render(); });
        dirsWrap.appendChild(btn);
      });

      const removeBtn = document.createElement('button');
      removeBtn.type = 'button'; removeBtn.className = 'ss-room-remove';
      removeBtn.textContent = '×'; removeBtn.setAttribute('aria-label','Remove destination');
      removeBtn.addEventListener('click', ()=>{ state.destinations.splice(i,1); render(); });

      row.appendChild(labelInput);
      row.appendChild(dirsWrap);
      row.appendChild(removeBtn);
      return row;
    }

    function bindDestControls(){
      const addBtn = root.querySelector('#ds-addRowBtn');
      const clearBtn = root.querySelector('#ds-clearBtn');
      if (addBtn) addBtn.addEventListener('click', ()=>{
        state.destinations.push({ label:'', direction:'right' });
        render();
      });
      if (clearBtn) clearBtn.addEventListener('click', ()=>{
        state.destinations = [];
        render();
      });
    }

    function bindTextInputs(){
      const headingEl = root.querySelector('#ds-headingText');
      if (headingEl){
        headingEl.value = state.headingText;
        headingEl.addEventListener('input', e=>{ state.headingText = e.target.value; render(); });
      }
      const plateEl = root.querySelector('#ds-plateColor');
      if (plateEl){
        plateEl.value = state.plateColor;
        plateEl.addEventListener('input', e=>{ state.plateColor = e.target.value; render(); });
      }
      const accentCustomEl = root.querySelector('#ds-accentCustomColor');
      if (accentCustomEl){
        accentCustomEl.value = state.accentCustomColor;
        accentCustomEl.addEventListener('input', e=>{ state.accentCustomColor = e.target.value; render(); });
      }
      const textColorEl = root.querySelector('#ds-textColor');
      if (textColorEl){
        textColorEl.value = state.textColor;
        textColorEl.addEventListener('input', e=>{
          state.textColor = e.target.value;
          state.textColorManual = true;
          render();
        });
      }
    }

    function render(){
      const shapeName = state.shape;
      // Backplate is sold as the "Offset Shadow" accent — picking that look IS
      // the paid backplate add-on, so Material (which is what actually prices
      // the variant) tracks the accent choice rather than being picked
      // separately. Matches the same pattern in Common Room / Room Number /
      // Restroom / Informational Studio.
      state.material = (state.accent==='shadow') ? 'backplate' : 'standard';
      const size = SIZES[state.size];
      const typeface = TYPEFACES[state.typeface];
      const plateW = 460, plateH = plateW * (size.h/size.w);
      const vbW = plateW+120, vbH = plateH+120;
      const px = (vbW-plateW)/2, py = (vbH-plateH)/2;
      const uid = state.material;
      const clipId = 'dsclip-' + sectionId;

      let defs = materialFillDefs(uid, state.plateColor);
      const plateFill = `url(#fill-${uid})`;
      defs += `<clipPath id="${clipId}">${shapeMarkup(shapeName, px, py, plateW, plateH, '', 8)}</clipPath>`;

      let standoffs = '';
      if (state.mounting==='standoff'){
        standoffs = standoffPoints(shapeName, px, py, plateW, plateH)
          .map(([cx,cy])=>`<circle cx="${cx}" cy="${cy}" r="5" fill="#8E7442"/><circle cx="${cx}" cy="${cy}" r="2" fill="#C6A05F"/>`).join('');
      }

      if (!state.textColorManual){
        state.textColor = MATERIALS[state.material].engrave;
      }
      const textColor = state.textColor;
      const plateStroke = 'rgba(255,255,255,0.55)';
      const plateShadow = shadowFilter(state.mounting);

      const accentColorValue = accentColorHex();
      const shadowBehindMarkup = state.accent==='shadow'
        ? offsetShadowMarkup(shapeName, px, py, plateW, plateH, accentColorValue) : '';
      const onTopAccentMarkup = (state.accent!=='none' && state.accent!=='shadow')
        ? accentOverlayMarkup(state.accent, px, py, plateW, plateH, accentColorValue) : '';

      const lines = state.destinations.filter(d=>d.label.trim());
      const hasHeading = !!state.headingText.trim();
      const headingFontSize = plateH*0.11;

      // Each non-rectangular shape curves inward differently — a flat 6%
      // margin is only safe for shapes with straight sides. Wavy pinches in
      // by ~14.4% of width at the vertical middle (exactly where 1-2 lines of
      // text land), and arch's dome narrows above ~24% of height, so both
      // need their own clearance instead of the generic rectangle margin.
      const SIDE_MARGIN  = { rectangle:0.06, arch:0.06, wavy:0.19, bowed:0.07, diagonal:0.06 };
      const TOP_MARGIN   = { arch:0.30 };
      const sideMargin = SIDE_MARGIN[shapeName] ?? 0.06;
      const minTopFrac = TOP_MARGIN[shapeName] || 0;

      // Side Stripe and Top & Bottom Bands carve out dedicated space — shift
      // the content area clear of them rather than drawing text on top.
      const hasStripe = state.accent==='stripe';
      const hasBands = state.accent==='bands';
      const contentLeftX = px + plateW*(hasStripe ? Math.max(0.14, sideMargin) : sideMargin);
      const contentRightFrac = 1 - sideMargin;
      const bandInset = hasBands ? plateH*0.15 : 0;

      // The accessible-route icon is a single badge for the whole sign, not
      // tied to any one destination — it reads best sitting inline with the
      // heading rather than floating separately. If there's a heading, the
      // icon sits at the right end of that same line (heading text is
      // left-aligned, so this balances it); if there's no heading, the icon
      // takes the heading's usual slot instead, so it still reserves its own
      // strip and never collides with a destination row.
      const hasIcon = state.icon === 'access';
      const hasHeadingRow = hasHeading || hasIcon;
      const iconInlineSize = headingFontSize*1.9;

      const headingTopFrac = Math.max(0.14, minTopFrac);
      const rowsTopFrac = hasHeadingRow ? headingTopFrac + 0.10 : Math.max(0.10, minTopFrac);
      const contentTop = py + plateH*rowsTopFrac + bandInset;
      const contentBottom = py + plateH*0.94 - bandInset;
      const usableRowsH = contentBottom - contentTop;
      const rowGap = usableRowsH / Math.max(lines.length,1);
      const maxLineFont = plateH*0.32;
      const minLineFont = 9;
      const lineFontSize = Math.max(minLineFont, Math.min(maxLineFont, rowGap*0.65));
      const startY = contentTop + rowGap*0.62;

      let rows = '';
      lines.forEach((d,i)=>{
        const y = startY + i*rowGap;
        const arrow = DIRECTIONS[d.direction].arrow;
        rows += `<text x="${contentLeftX}" y="${y}" font-family="${typeface.family}" font-weight="${typeface.weight}" font-size="${lineFontSize}" fill="${textColor}">${escapeXml(d.label)}</text>`;
        if (arrow) rows += `<text x="${px+plateW*contentRightFrac}" y="${y}" text-anchor="end" font-family="-apple-system,sans-serif" font-weight="700" font-size="${lineFontSize*1.1}" fill="${textColor}">${arrow}</text>`;
        if (i < lines.length-1) rows += `<line x1="${contentLeftX}" y1="${y+rowGap*0.32}" x2="${px+plateW*contentRightFrac}" y2="${y+rowGap*0.32}" stroke="${textColor}" stroke-width="0.6" opacity="0.22"/>`;
      });

      const headingBaselineY = py+plateH*headingTopFrac+bandInset;
      const iconCenterY = headingBaselineY - headingFontSize*0.35;
      const iconLeft = hasHeading
        ? px+plateW*contentRightFrac - iconInlineSize   // right end of the heading line
        : contentLeftX;                                  // takes the heading's slot when there's no heading text
      const iconMarkup = hasIcon
        ? `<g transform="translate(${iconLeft}, ${iconCenterY-iconInlineSize/2}) scale(${iconInlineSize/450})">${accessIconMarkup(textColor)}</g>`
        : '';

      const content = `
        ${hasHeading ? `<text x="${contentLeftX}" y="${py+plateH*headingTopFrac+bandInset}" font-family="-apple-system,sans-serif" font-weight="700" letter-spacing="2" font-size="${headingFontSize}" fill="${textColor}" opacity="0.7">${escapeXml(state.headingText.toUpperCase())}</text>` : ''}
        ${rows}
        ${iconMarkup}
      `;

      const svg = `
        <svg viewBox="0 0 ${vbW} ${vbH}" width="${vbW}" height="${vbH}" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Directional sign preview">
          <defs>${defs}</defs>
          ${shadowBehindMarkup}
          ${shapeMarkup(shapeName, px, py, plateW, plateH, `fill="${plateFill}" style="${plateShadow}" stroke="${plateStroke}" stroke-width="1"`, 8)}
          <g clip-path="url(#${clipId})">${onTopAccentMarkup}</g>
          ${standoffs}
          ${content}
        </svg>`;

      const stage = document.getElementById('ds-stage');
      let holder = stage.querySelector('.ss-svg-holder');
      if (!holder){
        holder = document.createElement('div');
        holder.className = 'ss-svg-holder';
        stage.insertBefore(holder, stage.querySelector('.ss-stage-caption'));
      }
      holder.innerHTML = svg;

      document.getElementById('ds-stage-dims').textContent = `${size.w}" × ${size.h}" — Directional`;
      document.getElementById('ds-stage-mount').textContent = MOUNTINGS[state.mounting].label;

      const textColorEl = root.querySelector('#ds-textColor');
      if (textColorEl && document.activeElement !== textColorEl) textColorEl.value = state.textColor;

      buildDestTable(root.querySelector('#ds-destTable'));
      const countEl = root.querySelector('#ds-destCount');
      if (countEl) countEl.textContent = state.destinations.length;

      buildChipRow(root.querySelector('#ds-shapeRow'), SHAPES, 'shape');
      buildChipRow(root.querySelector('#ds-typefaceRow'), TYPEFACES, 'typeface');
      buildChipRow(root.querySelector('#ds-sizeRow'), SIZES, 'size');
      buildChipRow(root.querySelector('#ds-mountingRow'), MOUNTINGS, 'mounting');
      buildChipRow(root.querySelector('#ds-iconRow'), ICONS, 'icon');
      buildChipRow(root.querySelector('#ds-accentRow'), ACCENTS, 'accent');
      const showAccentColor = ACCENTS[state.accent].needsColor;
      root.querySelector('#ds-accentColorField').style.display = showAccentColor ? '' : 'none';
      if (showAccentColor){
        buildChipRow(root.querySelector('#ds-accentColorRow'), ACCENT_COLORS, 'accentColor');
        root.querySelector('#ds-accentCustomColorField').style.display = (state.accentColor==='custom') ? '' : 'none';
      }

      // ---- ADA compliance is now standard on every sign, so nothing about
      // it is surfaced to the customer. Contrast still gets computed here
      // (silently) rather than deleted outright, in case a low-contrast
      // flag is wanted somewhere later — it just never reaches the DOM. ----
      const contrastPass = contrastRatio(textColor, state.plateColor) >= 4.5;
      const complianceEl = root.querySelector('#ds-complianceCheck');
      if (complianceEl) complianceEl.style.display = 'none';

      const variant = findVariant();
      const priceEl = document.getElementById('ds-priceValue');
      const unavailableEl = document.getElementById('ds-unavailable');
      const addBtn = document.getElementById('ds-addBtn');
      if (variant){
        priceEl.textContent = variant.price;
        if (!variant.available){
          unavailableEl.textContent = 'This combination is currently out of stock.';
          unavailableEl.style.display = '';
          addBtn.disabled = true;
        } else if (!lines.length){
          unavailableEl.textContent = 'Add at least one destination first.';
          unavailableEl.style.display = '';
          addBtn.disabled = true;
        } else {
          unavailableEl.style.display = 'none';
          addBtn.disabled = false;
        }
      } else {
        priceEl.textContent = '—';
        unavailableEl.textContent = "This exact combination isn't available yet — try a different size or mounting.";
        unavailableEl.style.display = '';
        addBtn.disabled = true;
      }
    }

    function addToCart(){
      const variant = findVariant();
      const lines = state.destinations.filter(d=>d.label.trim());
      if (!variant || !variant.available || !lines.length) return;
      const errorEl = document.getElementById('ds-error');
      const addBtn = document.getElementById('ds-addBtn');
      errorEl.style.display = 'none';
      addBtn.disabled = true;
      const originalLabel = addBtn.textContent;
      addBtn.textContent = 'Adding…';

      const properties = {
        'Destinations': lines.map(d => d.label + (DIRECTIONS[d.direction].arrow ? ' ' + DIRECTIONS[d.direction].arrow : '')).join(' | '),
        'Shape': SHAPES[state.shape].label,
        'Typeface': TYPEFACES[state.typeface].label,
        'Shape Color': state.plateColor,
        'Text Color': state.textColor
      };
      if (state.headingText.trim()) properties['Heading'] = state.headingText;
      if (state.icon!=='none') properties['Icon'] = ICONS[state.icon].label;
      if (state.accent!=='none'){
        properties['Accent Style'] = ACCENTS[state.accent].label;
        properties['Accent Color'] = state.accentColor==='custom' ? state.accentCustomColor : ACCENT_COLORS[state.accentColor].label;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1, properties: properties }] })
      })
      .then(res => res.json().then(body => ({ ok: res.ok, body })))
      .then(({ ok, body })=>{
        addBtn.disabled = false;
        if (!ok){
          errorEl.textContent = (body && body.description) || 'Could not add this to your cart. Please try again.';
          errorEl.style.display = '';
          addBtn.textContent = originalLabel;
          return;
        }
        addBtn.textContent = 'Added ✓';
        addBtn.classList.add('ss-added');
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: body } }));
        setTimeout(()=>{ addBtn.classList.remove('ss-added'); render(); }, 1800);
      })
      .catch(()=>{
        addBtn.disabled = false;
        addBtn.textContent = originalLabel;
        errorEl.textContent = 'Network error — please try again.';
        errorEl.style.display = '';
      });
    }

    root.querySelector('#ds-addBtn').addEventListener('click', addToCart);

    bindTextInputs();
    bindDestControls();
    render();
  }
})();
